import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeUp, Overline } from "../components/Reveal";

const sections = [
  {
    title: "Shipping",
    body: "Every Vincen order is dispatched with care and tracked from the atelier to your door. Shipping is complimentary on all pieces. Orders are typically prepared within 2\u20134 business days; delivery times vary by destination and are confirmed in your order notification.",
  },
  {
    title: "Packaging",
    body: "Each piece arrives in signature Vincen packaging \u2014 considered, protective, and worthy of the garment within. Your collectable is meant to be unwrapped as an occasion.",
  },
  {
    title: "Returns Window",
    body: "If a piece is not right for you, you may request a return within 14 days of delivery. Items must be unworn, unwashed, and returned with all original tags and packaging intact. Pieces showing wear, alteration, or the scent of cologne or smoke cannot be accepted.",
  },
  {
    title: "How to Return",
    body: "To begin a return, write to vinceninfo@gmail.com with your order details and reason. We will respond with return instructions. Return shipping is arranged by the customer unless the piece arrived faulty or incorrect, in which case the house covers it.",
  },
  {
    title: "Refunds",
    body: "Once your return is received and inspected, we will notify you of approval. Approved refunds are issued to the original method of payment within 5\u201310 business days. Please note the current checkout is a demonstration and processes no live payment.",
  },
  {
    title: "Exchanges",
    body: "The quickest way to secure a different size is to return the original piece and place a new order, subject to availability. Given the limited nature of our releases, we cannot reserve pieces during a return.",
  },
  {
    title: "Faulty or Incorrect Items",
    body: "If your piece arrives damaged, faulty, or not as ordered, contact us within 7 days of delivery at vinceninfo@gmail.com and we will make it right at no cost to you.",
  },
];

const Returns = () => {
  return (
    <div data-testid="returns-page" className="min-h-screen pt-28 md:pt-36 pb-28">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <Link
          to="/"
          data-testid="returns-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-zinc-500 hover:text-gold transition-colors duration-300"
        >
          <ArrowLeft size={13} /> The House
        </Link>

        <FadeUp>
          <div className="mt-10">
            <Overline>Information</Overline>
            <h1 className="mt-4 font-serif text-4xl md:text-6xl font-light text-[#F5F5F5] leading-tight">
              Returns &amp; Shipping
            </h1>
            <p className="mt-6 text-xs tracking-[0.3em] uppercase text-zinc-500">
              Last updated &mdash; June 2026
            </p>
          </div>
        </FadeUp>

        <div className="mt-16 flex flex-col gap-12">
          {sections.map((s, i) => (
            <FadeUp key={s.title} delay={0.05}>
              <div data-testid={`returns-section-${i}`} className="border-t border-white/10 pt-8">
                <h2 className="font-serif text-2xl md:text-3xl font-light text-[#F5F5F5]">
                  {s.title}
                </h2>
                <p className="mt-4 text-sm md:text-base text-zinc-400 leading-relaxed">
                  {s.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Returns;
